import { request } from "apis/base";
import {
  SalesOrderCreateBody,
  SalesOrderUpdateItemsBody,
} from "constants/types/salesOrder";

export const salesOrderApi = {
  getById: (id: string) => {
    return request({ url: `/sale-order/${id}`, method: "GET" });
  },

  create: (data: SalesOrderCreateBody) => {
    return request({ url: "/sale-order", method: "POST", data });
  },

  confirm: (id: string) => {
    return request({ url: `/sale-order/${id}/confirm`, method: "PATCH" });
  },

  cancel: (id: string) => {
    return request({ url: `/sale-order/${id}/cancel`, method: "PATCH" });
  },

  delete: (id: string) => {
    return request({ url: `/sale-order/${id}`, method: "DELETE" });
  },

  updateItems: (id: string, data: SalesOrderUpdateItemsBody) => {
    return request({ url: `/sale-order/${id}/items`, method: "PATCH", data });
  },

  updatePrintStatus: (id: string, isPrinted: boolean = true) => {
    return request({
      url: `/sale-order/${id}/print-status`,
      method: "PATCH",
      data: {
        isPrinted,
      },
    });
  },
};
